// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loading Fallback for Code-Split Routes - Story 2.4 */

.loading-fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: 2rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top: 4px solid var(--color-primary, #667eea);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { 
    transform: rotate(0deg); 
  }
  100% { 
    transform: rotate(360deg); 
  }
}

.loading-message {
  margin-top: 1rem;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

/* Dark theme compatibility */
@media (prefers-color-scheme: dark) {
  .loading-spinner {
    border: 4px solid rgba(255, 255, 255, 0.1);
    border-top: 4px solid var(--color-primary, #667eea);
  }
  
  .loading-message {
    color: rgba(255, 255, 255, 0.7);
  }
}

/* Light theme compatibility */
@media (prefers-color-scheme: light) {
  .loading-spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid var(--color-primary, #667eea);
  }
  
  .loading-message {
    color: rgba(0, 0, 0, 0.6);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoadingFallback.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,mDAAmD;EACnD,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE;IACE,0CAA0C;IAC1C,mDAAmD;EACrD;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,oCAAoC;IACpC,mDAAmD;EACrD;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Loading Fallback for Code-Split Routes - Story 2.4 */\n\n.loading-fallback {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  padding: 2rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-top: 4px solid var(--color-primary, #667eea);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { \n    transform: rotate(0deg); \n  }\n  100% { \n    transform: rotate(360deg); \n  }\n}\n\n.loading-message {\n  margin-top: 1rem;\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 500;\n}\n\n/* Dark theme compatibility */\n@media (prefers-color-scheme: dark) {\n  .loading-spinner {\n    border: 4px solid rgba(255, 255, 255, 0.1);\n    border-top: 4px solid var(--color-primary, #667eea);\n  }\n  \n  .loading-message {\n    color: rgba(255, 255, 255, 0.7);\n  }\n}\n\n/* Light theme compatibility */\n@media (prefers-color-scheme: light) {\n  .loading-spinner {\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-top: 4px solid var(--color-primary, #667eea);\n  }\n  \n  .loading-message {\n    color: rgba(0, 0, 0, 0.6);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
